/**
 * Build-time feature flags.
 *
 * UNIFIED_SESSIONS — Phase 2 of the session-architecture unification
 * (SESSION_UNIFICATION_PLAN.md). When true, the active-session screen
 * (SessionNotes) additionally mirrors its lifecycle (start → end → submit)
 * into the canonical companies/{companyId}/sessions record, so sessions
 * started from ANY entry point show up in My Sessions and the BCBA review,
 * and finished ones close their appointment.
 *
 * Kept OFF by default: with it off, the legacy sessionNotes flow is untouched
 * (the mirror calls are skipped), so shipping this is a no-op until we flip it
 * on after validating the full check-in → in-session → end → submit path.
 */
export const UNIFIED_SESSIONS = true;

/**
 * INVITE_ONBOARDING — multi-facility invite-code onboarding (CRA inlines
 * REACT_APP_* at build time). ON (default): a new account has no facility until
 * it redeems an invite code at /join; admins add staff directly (provisionUser)
 * or generate codes from the Users page. The security rules REQUIRE this — a
 * browser can no longer self-join a facility. Set
 * REACT_APP_INVITE_ONBOARDING=false only for the old single-company mode,
 * which the current rules will reject.
 */
export const INVITE_ONBOARDING = process.env.REACT_APP_INVITE_ONBOARDING !== 'false';
